import { useParams } from 'react-router-dom';
import { useDomesticRealEstateSymbolPage } from './hooks'
import { LoadingContainer, LoadingSize } from 'views/mutual/loading';
import { DomesticRealEstateSymbolDetail } from './symbolDetail';
import { DomesticRealEstateSymbolApplyConfirm  } from './symbolApplyConfirm';
import { DomesticRealEstateSymbolApplyPendingAdjustment } from './symbolApplyPendingAdjustment';
import { DomesticRealEstateContractComplete } from './contractComplete';
import { useEffect } from 'react';
import { NotFoundData } from 'views/mutual/notFoundData';
import { SymbolPageStep } from './hooks';
import { ApplicationStatusWrapper } from '../../module/applicationStatus';
import { CompatibilityCheck } from 'views/pages/compatibilityCheck';
import { ProductType } from 'constants/productType';
import { ContractCanceled } from 'views/pages/symbol/domesticRealEstate/apply/contractCanceled';

export const DomesticRealEstateSymbol = () => {
  const { symbol, id } = useParams<{ symbol: string, id: string }>();

  const {
    symbolPageStep,
    symbolDetailInfo,
    ApplicationAmountInfo,
    formik,
    canApplySymbol,
    impossobleDetailErrorText,
    check1Props,
    check2Props,
    check3Props,
    check4Props,
    backDetailPage,
    contractInfo,
  } = useDomesticRealEstateSymbolPage({ symbol: symbol!, id: id!});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [symbolPageStep]);

  const isFetching = symbolDetailInfo.fetching || ApplicationAmountInfo.fetching || contractInfo.fetching;
  if (isFetching) {
    return (
      <LoadingContainer isLoading={isFetching} size={LoadingSize.Medium}>
        <div></div>
      </LoadingContainer>
    );
  } else {
    if (!symbolDetailInfo.data?.GetDomesticRealEstateSymbolInfo || !contractInfo.data?.GetContractInfo) {
      return (
        <NotFoundData
          backPageType={{
            kind: 'previous',
          }}
        />
      );
    }

    switch (symbolPageStep) {
      case SymbolPageStep.Detail:
        return (
          <DomesticRealEstateSymbolDetail
          symbolDetail={symbolDetailInfo.data?.GetDomesticRealEstateSymbolInfo}
          formik={formik}
          canApplySymbol={canApplySymbol}
          impossobleDetailErrorText={impossobleDetailErrorText}
          check1Props={check1Props}
          check2Props={check2Props}
          check3Props={check3Props}
          check4Props={check4Props}
          />
        );
      case SymbolPageStep.CompatibilityCheck:
        return (
          <CompatibilityCheck
            assetType={ProductType.DomesticRealEstate}
            completedNextPage={{
              label: '申込内容確認に進む',
              navigate: formik.handleSubmit,
            }}
          />
        );
      case SymbolPageStep.ApplicationStatus:
        return (
          <ApplicationStatusWrapper
            assetType={ProductType.DomesticRealEstate}
            navigate={formik.handleSubmit}
            initializeFlags={{
              initializeHasValidFatcaAnswerFlag: true,
            }}
          />
        );
      case SymbolPageStep.Confirm:
        return (
          <DomesticRealEstateSymbolApplyConfirm
            symbolDetail={symbolDetailInfo.data?.GetDomesticRealEstateSymbolInfo}
            contractInfo={contractInfo.data?.GetContractInfo?.Details!}
            formik={formik}
            applicationID={id!}
            backDetailPage={backDetailPage}
          />
        );
      case SymbolPageStep.PendingAdjustment:
        return (
          <DomesticRealEstateSymbolApplyPendingAdjustment/>
        );
      case SymbolPageStep.ContractComplete:
        return (
          <DomesticRealEstateContractComplete
          contractInfo={contractInfo.data?.GetContractInfo?.Details!}
          />
        );
      case SymbolPageStep.ContractCanceled:
        return (
          <ContractCanceled/>
        );
    }
  }
};